import { makeStyles } from '@mui/styles';
import { isRtl } from '../../utils/isrtl';

export default makeStyles(() => ({
  openButton: {
    borderStyle: 'none',
    borderRadius: 10,
    height: 18,
    backgroundColor: '#BABABA',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
  },
  modalContentContainer: {
    backgroundColor: 'white',
    width: '100%',
    height: '27%',
    minHeight: 200,
    borderTopRightRadius: 18,
    borderTopLeftRadius: 18,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 32,
    paddingLeft: 28,
    paddingRight: 24,
    boxSizing: 'border-box',
    borderStyle: 'none',
  },
  textAndImgContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: (props) => (isRtl(props) ? 'row-reverse' : 'row'),
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  modalTitle: {
    fontSize: window.innerWidth * 0.05,
    fontWeight: '650',
    marginBottom: 16,
    textAlign: (props) => (isRtl(props) ? 'right' : 'left'),
    marginTop: 0,
  },
  modalText: {
    fontSize: window.innerWidth * 0.0386,
    color: '#949494',
    fontWeight: '400',
    marginTop: 0,
    // marginBottom: 24,
    textAlign: (props) => (isRtl(props) ? 'right' : 'left'),
    width: window.innerWidth * 0.53,
  },
  img: {
    width: 116,
    height: 72,
  },
  button: {
    width: '100%',
    backgroundColor: '#4CAF50',
    borderStyle: 'none',
    borderRadius: 12,
    height: '5.8%',
    minHeight: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: window.innerWidth * 0.0386,
    fontWeight: '400',
  },
  questionMarkLogo: {
    width: 18,
    height: 18,
    transform: (props) => (isRtl(props) ? 'scaleX(-1)' : ''),
  },
  popover: {
    width: 100,
    backgroundColor: 'red',
  },
}));
